module.exports = __webpack_public_path__ + "static/media/silver_spinyfin.3380f708.jpg";